import { buildDeliveryAvailability } from '@libs/analytics';
import type { DeliveryMethod, DeliveryMethodType, VariantDeliveryMethods } from '@libs/common-types';

import type { StockAvailability, YesNo } from '@/shared/analytics';

type BuildFBTDeliveryAvailabilityParams = {
    deliveryMethods: { [K in DeliveryMethodType]?: DeliveryMethod };
    tailoredVariant: Maybe<VariantDeliveryMethods>;
    purchaseOption: 'one-time' | 'autoship';
    isCustomPharmacyOOS: boolean;
};

type FBTDeliveryMethodResult = {
    sth_availability: YesNo;
    sth_stock_availability: Nullable<StockAvailability>;
    bopis_availability: YesNo;
    bopis_stock_availability: Nullable<StockAvailability>;
    sdd_availability: YesNo;
    sdd_stock_availability: Nullable<StockAvailability>;
};

/**
 * Builds delivery availability data specifically for FBT (Frequently Bought Together) products.
 *
 * FBT products only support BOPIS fulfillment, so STH and SDD are explicitly marked as "not available"
 * to indicate this is intentional behavior, not missing data.
 */
export function buildFBTDeliveryAvailability({
    deliveryMethods,
    tailoredVariant,
    purchaseOption,
    isCustomPharmacyOOS,
}: BuildFBTDeliveryAvailabilityParams): FBTDeliveryMethodResult {
    const deliveryAvailability = buildDeliveryAvailability({
        deliveryMethods,
        tailoredVariant,
        purchaseOption,
        isCustomPharmacyOOS,
    });

    return {
        bopis_availability: deliveryAvailability.bopis_availability,
        bopis_stock_availability: deliveryAvailability.bopis_stock_availability,
        sth_availability: 'not available',
        sth_stock_availability: 'not available',
        sdd_availability: 'not available',
        sdd_stock_availability: 'not available',
    };
}
